import { Modal, Spinner } from 'react-bootstrap';
import { Helpers } from '../../../utils/helpers';
import { AlertMessage } from '../../ui/AlertMessage/AlertMessage';
import { AlertStatus } from '../../ui/AlertMessage/AlertStatus';
import useSetPasswordModal from './useSetPasswordModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from '@fortawesome/free-solid-svg-icons';

interface SetPasswordModalProps {
  visible?: boolean;
  userId: string;
  onSuccess: () => void;
  onClose: () => void;
}

export const SetPasswordModal = ({
  visible = false,
  userId,
  onSuccess,
  onClose
}: SetPasswordModalProps) => {
  const manager = useSetPasswordModal(userId, onSuccess, onClose);

  return (
    <Modal
      show={visible}
      backdrop="static"
      keyboard={false}
      size="lg"
      centered={true}
      onHide={manager.closeModal}>
      <Modal.Header closeButton={true}>
        <Modal.Title>
          <FontAwesomeIcon icon={faKey} className="me-2" />
          Set Password
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertMessage
          status={AlertStatus.ERROR}
          message={manager.alertMessage}
          visible={!Helpers.isNullOrWhiteSpace(manager.alertMessage)}
        />
        <div className="mb-3">
          <label htmlFor="newPassword">New Password</label>
          <input
            id="newPassword"
            type="password"
            className={`form-control ${
              manager.fieldErrors.includes('password') ? 'is-invalid' : ''
            }`}
            value={manager.password}
            onChange={(e) => manager.updatePassword(e.currentTarget.value)}
            disabled={manager.isSubmitting}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="confirmPassword">Confirm Password</label>
          <input
            id="confirmPassword"
            type="password"
            className={`form-control ${
              manager.fieldErrors.includes('confirmPassword') ? 'is-invalid' : ''
            }`}
            value={manager.confirmPassword}
            onChange={(e) => manager.updateConfirmPassword(e.currentTarget.value)}
            disabled={manager.isSubmitting}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <button
          className="btn btn-secondary"
          disabled={manager.isSubmitting}
          onClick={() => manager.closeModal()}>
          Cancel
        </button>
        <button
          className="btn btn-primary"
          disabled={manager.isSubmitting}
          onClick={() => manager.submitPassword()}>
          <FontAwesomeIcon icon={faKey} className="me-1" />
          Set Password
          {manager.isSubmitting && <Spinner size="sm" animation="border" className="ms-2" />}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
